import { is, isValidObject } from "./is-type";
export function serialize(obj) {
    if (!isValidObject(obj)) {
        throw new Error("failed to serialize");
    }
    if (Array.isArray(obj)) {
        return JSON.stringify(obj.map(function (value) { return serialize(value); }));
    }
    else if (is.object(obj) && !is.null(obj)) {
        return Object.keys(obj)
            .sort()
            .map(function (k) { return k + ":" + serialize(obj[k]); })
            .join("|");
    }
    return JSON.stringify(obj);
}
//# sourceMappingURL=serialize.js.map